// components/SettingsPanel.js
import React from "react";
import { Chip, Button as MaterialButton } from "@mui/material";
import { useEditor } from "@craftjs/core";

const SettingsPanel = () => {
  const { selected, actions } = useEditor((state) => {
    // @ts-ignore
    const [currentNodeId] = state.events.selected;
    let selected;

    if (currentNodeId) {
      selected = {
        id: currentNodeId,
        name: state?.nodes[currentNodeId]?.data?.name,
        props: state?.nodes[currentNodeId]?.data?.props,
        displayName: state?.nodes[currentNodeId]?.data.displayName,
        settings: state?.nodes[currentNodeId]?.related && state?.nodes[currentNodeId]?.related.settings,
      };
    }

    return {
      selected,
    };
  });

  if (!selected) {
    return <div className="p-2">Select a component to edit its settings</div>;
  }

  const { settings } = selected;

  const renderSettings = () => {
    if (!settings) {
      return <div className="p-2">No settings available</div>;
    }

    return React.createElement(settings);
  };

  return (
    <div className="p-2">
      <div className="flex justify-end">
        <Chip
          size="small"
          label={selected.displayName}
        />
      </div>

      <div className="mt-2">{renderSettings()}</div>

      {settings && (
        <div className="mt-2">
          <MaterialButton
            className="w-full"
            variant="contained"
            size="small"
            color="error"
            onClick={() => actions.delete(selected.id)}
          >
            Delete
          </MaterialButton>
        </div>
      )}
    </div>
  );
};

export default SettingsPanel;
